/**
 * Utilities for constructing triage agent related URLs
 */
import {editBlobPath} from '@github-ui/paths'

/**
 * Default file path for the triage agent configuration file
 * When the server provides a different path, that should be used instead.
 */
export const DEFAULT_TRIAGE_AGENT_CONFIG_PATH = '.github/triage-agent.md'

type TriageAgentUrlParams = {
  repoOwner: string
  repoName: string
  defaultBranch?: string
  configPath?: string
}

/**
 * Constructs URL to edit existing triage-agent.md configuration file
 */
export function getTriageAgentConfigUrl({
  repoOwner,
  repoName,
  defaultBranch = 'main',
  configPath,
}: TriageAgentUrlParams): string {
  const filePath = configPath || DEFAULT_TRIAGE_AGENT_CONFIG_PATH
  return editBlobPath({
    owner: repoOwner,
    repo: repoName,
    commitish: defaultBranch,
    filePath,
  })
}

/**
 * Constructs URL to create new triage-agent.md configuration file
 */
export function getNewTriageAgentConfigUrl({
  repoOwner,
  repoName,
  defaultBranch = 'main',
}: TriageAgentUrlParams): string {
  return `/${repoOwner}/${repoName}/new/${defaultBranch}?triage-agent=1`
}
